export default __webpack_public_path__ + "static/media/mail.243ad945.svg";